import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47f41f9a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=47f41f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f41f9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f41f9a')) {
      api.createRecord('47f41f9a', component.options)
    } else {
      api.reload('47f41f9a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47f41f9a&scoped=true&", function () {
      api.rerender('47f41f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/official/vessel/index.vue"
export default component.exports